import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, NavigationStart, Router, RouterModule } from '@angular/router';
import { Store } from '@ngrx/store';
import { DeactivateModalComponent } from '@shared/components/deactivate-modal/deactivate-modal.component';
import { DeactivateModalService } from '@shared/components/deactivate-modal/deactivate-modal.service';
import {
  selectIsDivorceFlow,
  selectIsMultiInheritanceFlow,
  selectIsTrustToTrustFlow,
  State,
} from '@store/index';
import * as fromRootStore from '@store/index';
import { combineLatest, Subscription } from 'rxjs';

// component for blocking navigation with browser back button
@Component({
  selector: 'app-secure-container',
  templateUrl: './secure-container.component.html',
  providers: [{ provide: DeactivateModalService, useClass: DeactivateModalService }],
  imports: [RouterModule, DeactivateModalComponent, CommonModule],
  standalone: true,
})
export class SecureContainerComponent implements OnInit, OnDestroy {
  private subs: Subscription = new Subscription();
  private openModalFunction = this.openModal.bind(this);
  isDivorceTransfer: boolean = false;

  constructor(
    private router: Router,
    private deactivateModalService: DeactivateModalService,
    private globalStore: Store<State>,
  ) {}

  public ngOnInit(): void {
    this.subs.add(
      combineLatest([
        this.globalStore.select(selectIsDivorceFlow),
        this.globalStore.select(selectIsMultiInheritanceFlow),
        this.globalStore.select(selectIsTrustToTrustFlow),
        this.globalStore.select(fromRootStore.selectCwpInheritanceSaveStateToggle),
      ]).subscribe(
        ([isDivorce, isMultiInheritance, isTrustToTrust, isSaveToSessionStorageEnabled]) => {
          this.isDivorceTransfer = isDivorce;
          const isBackButtonEnabledForInheritance =
            (isMultiInheritance || isTrustToTrust) && isSaveToSessionStorageEnabled;
          // No back-button modal for divorce, multi-inheritance, or trust-to-trust flows
          if (!this.isDivorceTransfer && !isBackButtonEnabledForInheritance) {
            window.history.pushState(null, '', window.location.href);
            window.addEventListener('popstate', this.openModalFunction);

            let lastUrl = '';

            this.subs.add(
              this.router.events.subscribe((event) => {
                if (event instanceof NavigationEnd) {
                  window.history.pushState(null, '', window.location.href);
                  lastUrl = window.location.pathname;
                }
                if (
                  event instanceof NavigationStart &&
                  event.navigationTrigger === 'popstate' &&
                  event.url !== lastUrl
                ) {
                  this.router.navigate([lastUrl]);
                }
              }),
            );
          }
        },
      ),
    );
  }

  public ngOnDestroy(): void {
    this.subs.unsubscribe();
    window.removeEventListener('popstate', this.openModalFunction);
  }

  private openModal(): void {
    this.deactivateModalService.openModal();
  }
}
